import "./Footer.scss";
import { NavHashLink } from "react-router-hash-link";

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer id="footer" className="section-footer">
      <div className="container-footer">
        <div className="footer-logo">
          <a href="/" className="footer-main-brand">
            <span className="brand-title">Summarecon Tangerang</span>
          </a>
          <div className="footer-contact-info">
            <h3 className="footer-logo-title">Marketing Gallery</h3>
            <div className="footer-logo-text">Summarecon Tangerang</div>
            <div className="footer-logo-text">+6281212356556 - Mario</div>
          </div>
          <div className="footer-policies">
            <a href="/privacy-policy" className="footer-policy-link">
              Privacy Policy
            </a>
            <span className="policy-divider">|</span>
            <a href="/syarat-ketentuan" className="footer-policy-link">
              Syarat & Ketentuan
            </a>
          </div>
        </div>

        <div className="footer-sitemap">
          <div className="footer-site-link">
            <div className="footer-menu">
              <h4>Peta Situs</h4>
              <ul>
                <li className="nav-item">
                  <NavHashLink smooth to="/#about" className="nav-links">
                    About us
                  </NavHashLink>
                </li>
                <li className="nav-item">
                  <NavHashLink smooth to="/#promo" className="nav-links">
                    Promo
                  </NavHashLink>
                </li>
                <li className="nav-item">
                  <NavHashLink smooth to="/#lokasi" className="nav-links">
                    Lokasi
                  </NavHashLink>
                </li>
                <li className="nav-item" onClick={scrollToTop}>
                  <a href="/" className="nav-links">
                    Back to Top
                  </a>
                </li>
              </ul>
            </div>

            <div className="footer-menu">
              <h4>Produk Kami</h4>
              <ul>
                <li className="nav-item">
                  <NavHashLink smooth to="/#briza-lakes" className="nav-links">
                    Briza Lakes
                  </NavHashLink>
                </li>
                <li className="nav-item">
                  <NavHashLink smooth to="/#havena-lakes" className="nav-links">
                    Havena Lakes
                  </NavHashLink>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-rights">
        <div className="footer-disclaimer">
          Disclaimer : Halaman Informasi Properti Oleh PT Asia Rumah Utama
          diambil Resmi dari Info Properti Summarecon Tangerang. Harga,
          Spesifikasi dan Ketersediaan Unit dapat berubah sewaktu-waktu dan
          Diperlukan Konfirmasi.
        </div>
        <div className="footer-copyright">
          © {new Date().getFullYear()} Summarecon Tangerang. All Rights
          Reserved.
        </div>
        <div className="footer-powered">Powered by : PT. Asia Rumah Utama</div>
      </div>
    </footer>
  );
};

export default Footer;
